import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "@/style.css?vue&type=style&index=0&lang=css&external"
import "@/assets/vendor/bootstrap-icons/bootstrap-icons.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__